import { Card, CardContent, Grid, IconButton, Typography } from '@mui/material'
import React from 'react'
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import TaskIcon from '@mui/icons-material/Task';
import FeedIcon from '@mui/icons-material/Feed'
import { useNavigate, useParams } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';
import PersonIcon from '@mui/icons-material/Person';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import TimelapseIcon from '@mui/icons-material/Timelapse';
export const OpcionesMenuNav = ({ opciones }) => {
    const iconMapping = {
        HomeRepairServiceIcon: <HomeRepairServiceIcon />,
        TaskIcon: <TaskIcon />,
        FeedIcon: <FeedIcon />,
        ConstructionIcon: <ConstructionIcon />,
        PersonIcon: <PersonIcon />,
        AccountTreeIcon: <AccountTreeIcon />,
        CircleNotificationsIcon: <CircleNotificationsIcon />,
        AccessAlarmIcon: <AccessAlarmIcon />,
        TimelapseIcon: <TimelapseIcon />

    };
    const navigate = useNavigate();
    const param = useParams();
    return (
        <div className='menu-principal fade-in-2'>
            <Grid container spacing={3}
                sx={{ justifyContent: "center" }}>
                {opciones.map(opcion => (
                    
                    <Grid key={opcion.id}
                size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>                      
                        <Card
                            onClick={() => navigate(opcion.url)}
                            className="menu-card ki-interactive-card"
                        >
                            <CardContent className="ki-menu-card-content">
                                <IconButton color='primary'>
                                    {iconMapping[opcion.icon]}
                                </IconButton>
                                <Typography variant="h6" component="div">
                                    {opcion.nombre.toUpperCase()}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>

                ))}
            </Grid>
        </div>)
}
